import { TargetMap } from 'class-transformer'

export class Menus {
  constructor(
    public id: number,
    public slug: string,
    public name: string,
    public brief: string,
    public cover: string,
    public style: string,
    public lvl: number,
    public parentId: number | null,
    public children: Menus[],
    public hide: boolean,
    public sort: number,
    public adGroupDetail: AdGroupDetail | null,
    public seoTitle: string,
    public seoKeywords: string,
    public seoDescription: string
  ) {}
}

export class AdGroup {
  constructor(
    public id: number,
    public name: string
  ) {}
}

export class AdGroupDetail {
  constructor(
    public id: number,
    public name: string,
    public cover: string,
    public brief: string,
    public fullScreen: boolean = false,
    public adItems: AdItem[] | null = []
  ) {}
}

export class AdItem {
  constructor(
    public brief: string,
    public briefColor: string,
    public content: AdItemContent | null = null,
    public cover: string,
    public mobileCover: string,
    public coverHeight: number,
    public coverWidth: number,
    public description: string,
    public id: number,
    public sort: number,
    public status: number,
    public title: string,
    public titleColor: string,
    public type: number,
    public url: string,
    public videoUrl: string
  ) {}
}

export class AdItemContent {
  constructor(
    public id: number,
    public slug: string,
    public type: number,
    public subject: string,
    public name: string
  ) {}
}

export const MenuTarget: TargetMap[] = [
  {
    target: Menus,
    properties: {
      children: Menus,
      adGroup: AdGroup,
      adGroupDetail: AdGroupDetail,
    },
  },
  {
    target: AdGroupDetail,
    properties: {
      adItems: AdItem,
    },
  },
  {
    target: AdItem,
    properties: {
      content: AdItemContent,
    },
  },
]
